"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BatchQueue = void 0;
/**
 * A Queue which will process elements at intervals, only if the
 * queue contains any elements.
 */
var BatchQueue = /** @class */function () {
  function BatchQueue(batchPeriod, handler) {
    this.batchPeriod = batchPeriod;
    this.handler = handler;
    this.timeoutId = null;
    this.items = [];
  }
  BatchQueue.prototype.add = function (item) {
    var _this = this;
    this.items.push(item);
    if (this.timeoutId === null) {
      this.timeoutId = setTimeout(function () {
        _this.handleBatch();
      }, this.batchPeriod);
    }
  };
  BatchQueue.prototype.handleBatch = function () {
    var batch = this.items;
    this.timeoutId = null;
    this.items = [];
    this.handler(batch);
  };
  return BatchQueue;
}();
exports.BatchQueue = BatchQueue;